module.exports = __webpack_public_path__ + "static/dog-m-c9084c78f9fd2d552c7c5e658b973eeb.jpg";